class chooseYourWay {
  constructor() {
    const final = document.querySelector('.checkout-final') ? document.querySelector('.checkout-final') : null;

    if (final) {
      const choices = final.querySelectorAll('.js-update-shipping-provider>.radio__container') ? final.querySelectorAll('.js-update-shipping-provider>.radio__container') : null;

      if (choices) {
        choices.forEach((choice, index) => {
          choice.addEventListener('click', (e) => {
            choice.classList.add('radio-is-selected')
            choice.querySelector(".js-update-shipping-provider").setAttribute("checked", "checked")
            choices.forEach((ch, sindex) => {
              if(sindex !== index) {
                choice.querySelector(".js-update-shipping-provider").removeAttribute("checked")
                ch.classList.remove('radio-is-selected')
              }
            })
          })
        });
      }
    }
  }
}
module.exports = new chooseYourWay()